<template>
  <div class="animated fadeIn">
    <div v-if="entity.form">
        <b-form v-if="show" @submit.prevent.stop="formSubmit" @reset.prevent="formReset">

        <component v-if="form"
          :form="form"
          :submitted="submitted"
          :is="entity.form"
          :http="http"
          :nested="nested"
          :parent-entity="parentEntity">
          <!-- component changes when vm.currentView changes! -->

          <div slot="footer" class="text-right">
            <b-form-checkbox
              v-model="keepCreating"
              :value="true"
              :unchecked-value="false">

              Criar outro
            </b-form-checkbox>

            <b-button type="submit" :variant="processing ? 'secondary' : 'success'" :disabled="processing">
              {{ processing ? 'Enviando...' : 'Salvar' }}
            </b-button>
          </div>
        </component>

        <!-- <flash :fields="['UnprocessableEntity']"></flash> -->
      </b-form>
    </div>
  </div>
</template>

<script>
  import { get, omit } from 'lodash'
  import { mapActions } from 'vuex'
  import Form from '@/services/form'

  export default {
    props: {
      http: {
        type: Object,
        required: true
      },

      entity: {
        type: Object,
        required: true
      },

      nested: {
        type: Boolean,
        default: false
      },

      parentEntity: {
        type: Object,
        default () { return {} }
      }
    },

    data () {
      return {
        // Form data
        form: new Form({}),
        method: 'post',
        action: '',

        // Form handling
        processing: false,
        show: true,
        submitted: false,
        keepCreating: false
      }
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      }),

      formSubmit () {
        const self = this

        self.clearError(['UnprocessableEntity'])

        self.processing = true
        self.submitted = false
        self.$forceUpdate()
        // Before sending the form lets omit some paths
        self.form.populate(omit(self.form.data(), get(self.entity, 'formOptions.omit', [])))

        self.form[self.method](self.http.getRoute('store'))
          .then(([data, res]) => {
            self.submitted = true
            self.processing = false

            self.$emit('submitted', [data, res])

            self.$toasted.success('Criação realizada com sucesso')

            if (!self.keepCreating) {
              if (!self.nested) {
                // If it is not nested redirect to the index for the entity
                self.$router.push({
                  name: 'manageables.index',
                  params: { entity: self.$route.params.entity }
                })
              } else {
                self.$router.push({
                  name: 'manageables.edit',
                  params: {
                    entity: self.entity.parent,
                    id: self.$route.params.id
                  }
                })
              }
            }
          }).catch((e) => {
            self.submitted = true
            self.processing = false
          })
      },

      formReset () {
        /* Reset our form values */
        this.form.reset()
        this.processing = false
        this.submitted = false

        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => { this.show = true })
      }
    },

    created () {
      if (this.entity.create === false) {
        // this.$router.replace({ name: '404' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/manageables/Create.vue